/** 余额胶囊: ¥12.30。company_admin 可点进余额充值, 其他人只读。未开启计费时不渲染。 */
import { Link } from "react-router-dom";
import { Wallet } from "lucide-react";
import { fenToYuan } from "@/features/billing/utils";
import { cn } from "@/lib/utils";
import { useShell } from "./useShell";

export function BalanceChip({ className, inverse = false }: { className?: string; /** 绿色顶栏上 */ inverse?: boolean }) {
  const { showBalance, showBilling, balanceFen } = useShell();
  if (!showBalance || balanceFen === undefined) return null;

  const cls = cn(
    "inline-flex h-8 items-center gap-1.5 rounded-full border px-3 text-sm font-semibold tabular-nums",
    inverse ? "border-white/30 bg-white/15 text-white" : "bg-card text-foreground",
    className,
  );
  const body = (
    <>
      <Wallet aria-hidden className={cn("h-3.5 w-3.5", inverse ? "text-white" : "text-brand")} />
      <span className="sr-only">余额</span>¥{fenToYuan(balanceFen)}
    </>
  );
  return showBilling ? (
    <Link
      to="/billing"
      title="余额充值"
      className={cn(cls, "transition-colors focus-visible:outline-none focus-visible:ring-2", inverse ? "hover:bg-white/25 focus-visible:ring-white/70" : "hover:border-brand/40 hover:bg-primary-soft focus-visible:ring-ring")}
    >
      {body}
    </Link>
  ) : (
    <span className={cls} title="当前余额">
      {body}
    </span>
  );
}
